import api from "../../helpers/api";


export const getCustomers = (body) => api.post('customer/search-customers', {...body})

export const getCustomer = (id) => api.get(`customer/${id}`)

export const createCustomer = (formData) => api.post('customer' , {...formData})

export const createStagingCustomer = (formData) => api.post(`customer-staging/create`, {...formData})

export const updateCustomer = (id , formData) => api.put(`customer/${id}` , {...formData})

export const getFavArtisanProducts = (customerId) => api.post(`customer/getfavorites-artisans/`,customerId)

export const getFavSupplierProducts = (customerId) => api.post(`customer/getfavorites-suppliers/`, customerId)

export const updateCustomerLimit = (body) => api.put(`customer/limits/customer-inquiries-limits/`, body)

export const addFavArtisanProduct = (customerId,productID) => api.post(`customer/addfavorite-artisan/`, customerId, productID)

export const addFavSupplierProduct = (customerId,productID) => api.post(`customer/addfavorite-supplier/`, customerId, productID)

export const remFavArtisanProduct = (customerId, productID) => api.post(`customer/remfavorite-artisan/`,customerId, productID)

export const remFavSupplierProduct = (customerId, productID) => api.post(`customer/remfavorite-supplier/`,customerId, productID)